import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import { withKDevPageError } from '@kdev-fe-common/common/errorHandler/KDevPageError';
import { EErrorType, uploadPageError } from '@/index.config/weblogger';
export function initErrorHandle() {
  withKDevPageError.errorHandleConfig.uploadPageError = function (error) {
    uploadPageError({
      event_type: EErrorType.PAGE_ERROR,
      result_type: error.name,
      message: error.message,
      extra_info: JSON.stringify({
        stack: error.stack
      })
    }, error);
  };
}